/* global fetch */
import { isFunction } from 'lodash';
import { clearLocalStorage } from './paypal-utils';

const cancel = (callback) => {
	return (data, actions) => {
		// Show a cancel page, or return to cart
		// Call endpoint to clear address
		clearLocalStorage();

		//This call back can be used to hide a loading spinner
		if (isFunction(callback)) {
			callback(false);
		}
	};
};

module.exports = cancel;
